import generateAccountingCode from '../accounting-mapping.js'

export default function makeRows (cellsTable, groupHeadersMap) {
  console.log('makeRows', cellsTable)

  // const cellsTable = instance.data?.cellsTable

  let rows = cellsTable.reduce((rows, cell) => {
    const existingRow = rows.find(row => row.originalRowNumber === cell.rowNumber)

    const row = existingRow || {
      originalRowNumber: cell.rowNumber,
      cells: []
    }

    row.cells.push(cell)

    // Extract the data for mapping of columns
    const columnName = columnsMapping[cell.columnName]
    if (columnName) {
      row[columnName] = cell.value
    }

    if (!existingRow) rows.push(row)

    return rows
  }, [])
  console.log('rows', rows)

  rows.map(computeRowFormulas)
  console.log('rows with Formulas', rows)

  generateAccountingCodes(rows)
  console.log('rows with Accounting Codes', rows)

  rows = rowsWithGroups(rows, 'Code', groupHeadersMap)
  console.log('rows with Groups', rows)

  return rows
}

const columnsMapping = {
  Code: 'Code',
  Description: 'Description',
  Rate: 'Rate',
  'PRE-PRODN. Wks': 'PRE-PROD Wks',
  'PRE-PRODN. Amount': 'PRE-PROD Amount',
  'SHOOT Wks': 'SHOOT Wks',
  'SHOOT Amount': 'SHOOT Amount',
  'POST-PRODN. Wks': 'POST-PROD Wks',
  'POST-PRODN. Amount': 'POST-PROD Amount',
  QAPE: 'QAPE',
  'Stage of Production': 'Stage of Production'
}

function computeRowFormulas (row) {
  row.TotalProduction = row['PRE-PROD Amount'] + row['SHOOT Amount'] + row['POST-PROD Amount']
  return row
}

function generateAccountingCodes (rows) {
  const accountingCodes = []
  rows.forEach(row => {
    row.AccountingCode = generateAccountingCode(row, accountingCodes)
    accountingCodes.push(row.AccountingCode)
  })
  return accountingCodes
}

const columnGrouping = {
  'PRE-PROD Amount': 'sum',
  'SHOOT Amount': 'sum',
  'POST-PROD Amount': 'sum',
  TotalProduction: 'sum',
  QAPE: 'sum'
}

function computeGroupTotal (rows, columnGrouping) {
  const groupTotals = {}
  rows.forEach(row => {
    Object.entries(columnGrouping).forEach(([column, grouping]) => {
      groupTotals[column] = groupTotals[column] || 0

      if (grouping === 'sum') {
        groupTotals[column] += row[column] || 0
      }
    })
  })
  return groupTotals
}

// rowsWithGroups(rows, 'Code')
function rowsWithGroups (rows, groupBy, groupHeadersMap) {
  console.log('rowsWithGroups', rows)

  let position = 0
  const groupedRows = rows.reduce((rowGroups, row) => {
    const rowValue = row[groupBy]
    rowGroups[rowValue] = rowGroups[rowValue] || {
      position,
      rows: []
    }
    rowGroups[rowValue].rows.push(row)
    position++
    return rowGroups
  }, {})
  console.log('groupedRows', groupedRows)

  const newRows = []

  Object.entries(groupedRows).forEach(([key, value]) => {
    console.log('groupedRows', key, value)
    // Adding header
    const headerRow = {
      position: value.position,
      rows: value.rows,
      header: key,
      Code: key,
      type: 'header'
    }

    console.log('groupHeadersMap', groupHeadersMap)
    const groupHeader = Object.values(groupHeadersMap).find(groupHeader => groupHeader.code === key)
    console.log('groupHeader', groupHeader)
    // headerRow.Code = groupHeader.code
    headerRow.Description = groupHeader?.description || ''

    newRows.push(headerRow)

    // The sub rows
    value.rows.forEach(row => {
      const subRow = {
        ...row
      }
      newRows.push(subRow)
    })

    // Adding sub totals
    const subTotals = computeGroupTotal(value.rows, columnGrouping)

    const subTotalRow = {
      Code: key,
      Description: `Sub Total for ${groupHeader?.description}`,
      rows: value.rows,
      type: 'subTotal',
      ...subTotals
    }

    newRows.push(subTotalRow)

    // Empty row
    const emptyRow = {
      // ...headerRow,
      // Code: '',
      type: 'break'
    }
    newRows.push(emptyRow)
  })
  console.log('newRows', newRows)

  return newRows
}
